<template>
  <Layout>
    <template v-slot:title>Mis Favoritos</template>
    <div class="max-w-screen-2xl mx-auto">
      <VideosList>
        Lo sentimos, la lista está vacía.
      </VideosList>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/MainLayout'
import VideosList from '@/components/VideosList'

export default {
  components: { Layout, VideosList },

  props: {
    ids: {
      type: String,
      required: true,
    },
  },

  mounted() {
    this.$store.dispatch('favorites/fetchSharedFavoritesList', this.ids)
  },
}
</script>
